export const genericErrorMessage = `Oops! Something Went Wrong...
Our developers are currently in a staring contest with this problem. The winner gets to fix it.
Please come back later to check it out!`
